export default {
  // 推送策略 - 获取当前企业数据推送策略列表
  getPushRules: {
    server: '/push-rules',
    method: 'get',
  },
  // 推送策略 - 创建数据推送策略
  addPushRules: {
    server: '/push-rules',
    method: 'post',
  },
  // 推送策略 - 删除数据推送策略
  deletePushRules: {
    server: '/push-rules/{pushRuleId}',
    method: 'delete',
  },
  // 推送策略 - 更新数据推送策略
  updatePushRules: {
    server: '/push-rules/{pushRuleId}',
    method: 'patch',
  },
  // 获取策略绑定的测点
  getPoints: {
    server: '/push-rules/{pushRuleId}/points',
    method: 'get',
  },
};
